import { handleBridgePrompt } from '../../agents/acp/from-bridge/handle-bridge-prompt.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handlePromptMessage: BridgeMessageHandler<'prompt'> = (msg, deps) => {
  handleBridgePrompt(msg, deps);
};
